
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 160.58 141.05"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.39 89.7l-4-4.67C24.9 76.3 11 79.39 8.56 90.34L.29 126.91A11.58 11.58 0 0012.4 141l37.4-2.61c11.2-.78 16.36-14 8.87-22.74l-4-4.67 69.53-59.65 4 4.67c7.49 8.73 21.36 5.64 23.83-5.31l8.27-36.57A11.59 11.59 0 00148.18 0l-37.4 2.61c-11.2.78-16.36 14-8.87 22.74l4 4.67z","fill":"#868179"}})])
          )
        }
      }
    